import React from "react";

export default function InvesticneRozsireneMoznostiKarta({
  investScenareOpen,
  setInvestScenareOpen,
  investRentaOpen,
  setInvestRentaOpen,
  vyvojInvesticieRezim,
  setVyvojInvesticieRezim,
}) {
  return (
    <div className="card-section card-section--invest-rozsirene">
      <h2>Rozšírené možnosti:</h2>

      <div className="toggle-group invest-rozsirene-toggles">
        <label className="chk">
          Scenáre:
          <input
            type="checkbox"
            checked={investScenareOpen}
            onChange={(e) => setInvestScenareOpen(e.target.checked)}
          />
        </label>

        <label className="chk">
          Renta:
          <input
            type="checkbox"
            checked={investRentaOpen}
            onChange={(e) => setInvestRentaOpen(e.target.checked)}
          />
        </label>

        <div className="toggle-group invest-rozsirene-vyvoj">
          <span className="invest-rozsirene-vyvoj-label">Vývoj investície:</span>

          <label className="chk">
            <input
              type="checkbox"
              checked={vyvojInvesticieRezim === "mesiace"}
              onChange={() => setVyvojInvesticieRezim(vyvojInvesticieRezim === "mesiace" ? null : "mesiace")}
            />
            Mesiace
          </label>

          <label className="chk">
            <input
              type="checkbox"
              checked={vyvojInvesticieRezim === "roky"}
              onChange={() => setVyvojInvesticieRezim(vyvojInvesticieRezim === "roky" ? null : "roky")}
            />
            Roky
          </label>
        </div>
      </div>
    </div>
  );
}